import React from 'react';

export const Divider = () => (
  <div className="form__row form__row_2">
    <div className="form-line" />
  </div>
);
